import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { Button } from "../../elements/Button";

import { useGlobalContext } from "../../context";

const HeroSection = () => {
  const { name, image } = useGlobalContext();

  return (
    <Wrapper>
      <div className="container grid grid-two-column">
        <div className="section-hero-data">
          <p className="hero-top-data">THIS IS</p>
          <h1 className="hero-heading">{name}</h1>
          <p className="hero-para">
          Ani kotas home tuitions for cbse and rbse (5 - 10) is started from 2017. we teach online and offline both students. our tuition center is most reliable education center in kota, jaipur. we teach class 5, 6, 7, 8, 9, 10 of  CBSE(Central Board of Secondary Education) and rbse(rajasthan board seccondary education) both. By the many years of experience and our growth we can say that we are the best in our teaching field. Our students and their prentes are always satisfied with our services and teaching. At the end of every year we proudly announce and appreciate all our gems for their improvement.
          </p>
          <div>
            <Button className="btn hireme-btn">
              <a href={`tel: +919982852960`}> Call Us</a>
            </Button>
            <Button className="btn hireme-btn">
              <NavLink to="/contact"> Contact Us </NavLink>
            </Button>
          </div>
        </div>

        {/* for image  */}
        <div className="section-hero-image">
          <picture>
            <img src={image} alt="hero image" className="hero-img " />
          </picture>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  padding: 9rem 0;
  .section-hero-data {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .btn {
    max-width: 16rem;
  }
  .hero-top-data {
    text-transform: uppercase;
    font-weight: 700;
    font-size: 2.5rem;
    color: black;
  }
  .hero-heading {
    text-transform: uppercase;
    font-size: 4.5rem;
    color: black;
  }
  .hero-para {
    margin-top: 1.5rem;
    font-weight: 500;
    font-size: 2rem;
    margin-bottom: 3.4rem;
    // max-width: 60rem;
    color: #000000;
  }
  .section-hero-image {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  picture {
    text-align: center;
  }
  .hero-img {
    max-width: 100%;
  }

  .grid {
    display: grid;
    gap: 9rem;
  }
  .grid-two-column {
    grid-template-columns: repeat(2, 1fr);
  }
  .grid-three-column {
    grid-template-columns: repeat(3, 1fr);
  }
  .grid-four-column {
    grid-template-columns: 1fr 1.2fr 0.5fr 0.8fr;
  }

  @media (max-width:998px) {
    .hero-para {
      font-size: 2.8rem;
      }
      .grid {
        display: grid;
        gap: 0rem;
      }    
  }
  
  @media (max-width:768px) {
    .grid-two-column {
      grid-template-columns: repeat(2, 1fr);
    }
    .section-hero-image {
      // display: none;
    }
  }
  @media (max-width:599px) {
    .grid-two-column {
      grid-template-columns:none;
    }
    .section-hero-data {
    order: 1;
    }
    .hero-img {
      max-width: 70%;
  }
  }
`;
export default HeroSection;
